import request from '@/utils/request'
import https from '@/utils/https.js'
export function getSchoolList(form, area, page) {
    return https({
        url: '/api/single/school_info',
        method: 'post',
        data: {
            scl_name: form.scl_name,
            zslx: form.zslx,
            scl_nature: form.scl_nature,
            scl_nature_type: form.scl_nature_type,
            city: form.city,
            page: page,
            limit: '20',
            area: area
        }
    })
}